import { SubRouteAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BusinessPartnerService } from "app/modules/components/business-partners/business-partner/business-partner.service";
import { DeleteConfirmationComponent } from "app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component";
import { SubRouteFrequenciesBPService } from "../../sub-routes-frequency/sub-route-frequencies-bp.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FuseLoadingService } from "@fuse/services/loading";
import { CalendarA11y, CalendarDateFormatter, CalendarModule, CalendarUtils, CalendarView, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CustomDatesModalComponent } from "../modal-w-frequencies/modal-w-frequencies.component";

@Component({
  selector: 'app-business-partner-sub-routes-modal',
  styleUrl: './business-partner-sub-routes.component.scss',
  templateUrl: './business-partner-sub-routes.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    CalendarModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatTooltipModule,
  ],
  providers: [
    CalendarUtils,
    CalendarA11y,
    CalendarDateFormatter,
    {
      provide: DateAdapter,
      useFactory: adapterFactory
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BusinessPartnerSubRoutesModalComponent {

  dataSourceBusinessPartnerSubRoutes = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    //"nro",
    "name",
    "frequencies",
    "action"
  ];

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex = 1
  sortActive: keyof SubRouteAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";
  searchQuery: string = '';
  private _fuseLoadingService = inject(FuseLoadingService);
  daysList: { code: number; day: string }[] = [
    {code: 1, day: "LU"},
    {code: 2, day: "MA"},
    {code: 3, day: "MI"},
    {code: 4, day: "JU"},
    {code: 5, day: "VI"},
    {code: 6, day: "SA"},
    {code: 7, day: "DO"}
  ];

  constructor(
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly subRouteFrequenciesBPService: SubRouteFrequenciesBPService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BusinessPartnerSubRoutesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.setUpSubRoutesByBusinessPartner();
  }

  setUpSubRoutesByBusinessPartner() {
    this.dataSourceBusinessPartnerSubRoutes.data = this.data.subRoutes;

    this.dataSourceBusinessPartnerSubRoutes.data.forEach(item => {
      const enhancedItem = item as any;

      enhancedItem.bpDayFrecuenciesLength = item.frequencies?.filter(f => f.type === 'W').length || 0;
      enhancedItem.bpCustomFrecuenciesLength = item.frequencies?.filter(f => f.type === 'C').length || 0;

      const uniqueDays = [
        ...new Set(
          item.frequencies?.flatMap(f => f.days || []) || []
        )
      ].sort((a, b) => (Number(a) || 0) - (Number(b) || 0));

      enhancedItem.bpDaysInAllFrecuencies = uniqueDays
        .map(dayCode => this.daysList.find(day => day.code === dayCode)?.day)
        .filter(Boolean)
        .join(', ');
    });
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    //if(this.searchQuery && this.searchQuery != ''){
    this.dataSourceBusinessPartnerSubRoutes.data = this.data.subRoutes.filter(sr =>
      sr.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
    /*}else{
      this.dataSourceBusinessPartnerSubRoutes.data = this.data.subRoutes;
    }*/

  }

  onDeleteSubRouteByBussinessPartner(index, element) {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: {
          message: `¿Estás seguro de eliminar al cliente de la ruta?`,
          //name: item,
        },
        panelClass: "delete-modal",
        disableClose: true
      })
      .afterClosed()
      .subscribe((result) => result && this.onDeleteBpFromSubRoute(index, element));
  }

  async onDeleteBpFromSubRoute(index, element) {
    let frecuenciesId = element.frequencies.map(f => f._id)
    const promises = element.frequencies.map(f =>
      this.subRouteFrequenciesBPService.deleteBusinessPartnerFromFrecuency(
        element._id,
        f._id,
        this.data.businessPartner._id,
      )
        .toPromise()
    );

    Promise.all(promises)
      .then(() => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", { duration: 5000, verticalPosition: "top" })
        //arr.splice(2, 1);
        let bpSubRouteList = this.dataSourceBusinessPartnerSubRoutes.data.slice();
        bpSubRouteList.splice(index, 1);
        this.dataSourceBusinessPartnerSubRoutes.data = bpSubRouteList;
      })
      .catch((error) => {
        this.snackBar.open(error?.error?.message || "Registro actualizado con éxito", "Cerrar", { duration: 5000, verticalPosition: "top" })
      });
  }

    openCustomFrequenciesModal(element: any) {
      const dialogRef = this.dialog.open(CustomDatesModalComponent, {
        data: {
          frequencies: element
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
    }

}